import { useOneClick } from 'contexts/OneClickBuyContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from './styles';

const NewCardNotice: React.FC = () => {
	const { isNewCardRequired } = useOneClick();
	const { t } = useTranslation('upsell');

	if (!isNewCardRequired) return null;

	return (
		<Container role='note'>
			<p>{String(t('newCard.checkoutNotice'))}</p>
		</Container>
	);
};

export default NewCardNotice;
